import {
  Body,
  Button,
  FlexContainer,
  Heading3,
  LocaleDictionaryType,
  useLocales,
  useScreenWidth,
} from "@/lib/main";

type Props = {
  title?: LocaleDictionaryType;
  message: LocaleDictionaryType;
  confirmText: LocaleDictionaryType;
  cancelText: LocaleDictionaryType;
  handleConfirmClick: () => void;
  handleCancelClick: () => void;
  breakpoint?: number;
};

export default function ConfirmModalContent({
  title,
  message,
  confirmText,
  cancelText,
  handleConfirmClick,
  handleCancelClick,
  breakpoint,
}: Props) {
  const l = useLocales();
  const { screenWidth, tabletBreakpoint } = useScreenWidth();

  const flexDirection =
    screenWidth < (breakpoint ?? tabletBreakpoint) ? "column" : "row";

  return (
    <>
      {title ? <Heading3 textAlign="center">{l(title)}</Heading3> : null}
      <FlexContainer direction="column" gap="xl">
        <Body textAlign="center">{l(message)}</Body>

        <FlexContainer
          direction={flexDirection}
          gap="xl"
          justify="start"
          fullWidth
        >
          <Button color="danger" onClick={handleCancelClick} fullWidth>
            {l(cancelText)}
          </Button>

          <Button color="brand" onClick={handleConfirmClick} fullWidth>
            {l(confirmText)}
          </Button>
        </FlexContainer>
      </FlexContainer>
    </>
  );
}
